import { Component, OnInit } from '@angular/core';
import { GlobalFunctionsGui } from 'globales-projekt-angular';

@Component({
  selector: 'app-ueber-baukost',
  templateUrl: './ueber-baukost.component.html',
  styleUrls: ['./ueber-baukost.component.css']
})
export class UeberBaukostComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  onClickUp() {
    GlobalFunctionsGui.clickUp();
  }

  onClickDown() {
    GlobalFunctionsGui.clickDown();
  }


}
